"use client";
import { usePageInfoContext } from "../PageInfo/context";
import { useProductsContext } from "./context";
import { useCallback } from "react";
import { useFilterConditionContext } from "../FilterCondition/context";
import { formattingUrl } from "@/lib/commonService";

export type FetchProductsType = "filter" | "scroll";

export function useFetchProducts() {
    const [is_personalize, is_secondary, page_id] = usePageInfoContext(
        (state) => [state.is_personalize, state.is_secondary, state.page_id],
    );
    const fetchProducts = useProductsContext((state) => state.fetchProducts);
    const outputCondition = useFilterConditionContext(
        (state) => state.outputCondition,
    );
    const requestProductsData = useCallback(
        (type: FetchProductsType, param?: Record<string, any>) => {
            const condition = { ...outputCondition(), ...param };
            // url修改
            formattingUrl(condition, `/specsubs?id=${page_id}`);
            fetchProducts(
                {
                    is_personalize,
                    is_secondary,
                    pageId: page_id,
                    params: condition,
                },
                type,
            );
        },
        [outputCondition, fetchProducts, is_personalize, is_secondary, page_id],
    );
    return requestProductsData;
}
